const mEditionMapEnrollmentsDropDownFilters = {
  mEditionMapEnrollmentsDropDownFilters: {
    input: {
      estado: {
        label: 'Estado de Inscripción'
      },

      fecha: {
        label: 'Fecha de Inscripción',
        desde: {
          placeholder: 'Desde - DD MM, AAAA'
        },

        hasta: {
          placeholder: 'Hasta - DD MM, AAAA'
        }
      },

      search: {
        label: 'Email o Nombre y Apellido',
        placeholder: 'alumno@email.com'
      }
    },

    buttons: {
      reload: 'ACTUALIZAR',
      search: 'FILTRAR'
    }
  }
}

export default mEditionMapEnrollmentsDropDownFilters
